import { render, staticRenderFns } from "./SearchArticleWithStockModel.vue?vue&type=template&id=da8a3710&scoped=true"
import script from "./SearchArticleWithStockModel.vue?vue&type=script&lang=js"
export * from "./SearchArticleWithStockModel.vue?vue&type=script&lang=js"
import style0 from "./SearchArticleWithStockModel.vue?vue&type=style&index=0&id=da8a3710&prod&scoped=true&lang=css"
import style1 from "./SearchArticleWithStockModel.vue?vue&type=style&index=1&id=da8a3710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8a3710",
  null
  
)

export default component.exports